/**
 * Email icon for the clinic orders page header (immediately left of Export,
 * same variant and size). Owns the LPO email modal's open state so the page
 * wires one line and passes it the SAME list parameters the page's own query
 * runs with; the modal reuses that query, so scope and RLS are the page's.
 * Clipboard feature: nothing is sent.
 */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Mail } from 'lucide-react';
import { Button } from '@insolech/ui';
import type { orderQueries } from '@insolech/sdk';
import { LpoEmailModal } from './LpoEmailModal';

interface Props {
  /** The page's current list parameters (scope: clinic / podiatrist / agent). */
  listParams: orderQueries.OrderListParams;
}

export function LpoEmailButton({ listParams }: Props): React.ReactElement {
  const { t } = useTranslation(['orders']);
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Button
        variant="outline"
        size="md"
        onClick={() => setOpen(true)}
        aria-label={t('orders:lpo_button')}
        title={t('orders:lpo_button')}
        data-testid="lpo-email-button"
      >
        <Mail className="h-4 w-4" />
      </Button>
      {open ? <LpoEmailModal open={open} onOpenChange={setOpen} listParams={listParams} /> : null}
    </>
  );
}
